import { CategorizedTreatment } from '@customTypes/CategorizedTreatment'
export const findTreatmentInCategorizedTreatments = (
  categorizedTreatments: CategorizedTreatment[],
  treatmentId: string
) =>
  categorizedTreatments
    .flatMap((category) => category.treatmentBundles)
    .find((treatment) => treatment.referenceId === treatmentId)
